import React, { useState } from "react";
import { AccordionContainer } from "./Accordion.styled";
import { SegmentSubTitle } from "../SegmentSettings/SegmentSettings.styled";

const CustomAccordion = ({
  title,
  icon,
  children,
  padding,
  expanded = false,
  secondaryIcon = null,
  // T22.154: optional controlled mode. When `onToggle` is passed, `expanded` is
  // the source of truth and a header click/Enter/Space calls onToggle(next).
  // Callers without it keep `expanded` as the initial state only.
  onToggle,
}) => {
  const [localExpanded, setLocalExpanded] = useState(expanded);
  const isExpanded = onToggle ? expanded : localExpanded;

  const handleToggle = () => {
    if (onToggle) onToggle(!expanded);
    else setLocalExpanded((prev) => !prev);
  };

  return (
    <AccordionContainer className={isExpanded ? "expanded" : ""}>
      <div
        className="accordion-summary"
        onClick={handleToggle}
        role="button"
        tabIndex={0}
        aria-expanded={isExpanded}
        onKeyDown={(e) => {
          // Only the header itself: Space on a switch inside secondaryIcon
          // must flip the switch, not the section.
          if (e.target !== e.currentTarget) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        <SegmentSubTitle>{title}</SegmentSubTitle>
        <div className="accordion-icon">
          {secondaryIcon && secondaryIcon}
          {icon}
        </div>
      </div>
      <div className="accordion-details" style={{ padding }}>
        {children}
      </div>
    </AccordionContainer>
  );
};

export default CustomAccordion;
